import { useTranslation } from 'react-i18next';
import { useAuth } from '@entities/auth';
import { formatDateTime, isFutureIso } from '@shared/lib/format-date-time';
import { StatusBanner } from '@shared/ui';

export interface WithdrawalsLockBannerProps {
  /** Если задано — дата блокировки с API настроек; иначе из сессии пользователя */
  lockedUntil?: string | null;
}

export function WithdrawalsLockBanner({ lockedUntil: lockedUntilProp }: WithdrawalsLockBannerProps = {}) {
  const { user } = useAuth();
  const { t, i18n } = useTranslation('cabinet');
  const lockedUntil = lockedUntilProp ?? user?.withdrawalsLockedUntil;

  if (!isFutureIso(lockedUntil)) {
    return null;
  }

  return (
    <StatusBanner variant="pending">
      {t('withdrawal.lock.banner', {
        datetime: formatDateTime(lockedUntil ?? '', i18n.language),
      })}
    </StatusBanner>
  );
}

export const useWithdrawalsLocked = (): boolean => {
  const { user } = useAuth();
  return isFutureIso(user?.withdrawalsLockedUntil);
};
